import styled, { keyframes } from 'styled-components'
import { Surface, Colors } from '@pinchenterprisesnpm/friday-ui'

/* -------------------------------------------------------------------------- */
/*                                Animation                                   */
/* -------------------------------------------------------------------------- */

const skeletonAnimation = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`

/* -------------------------------------------------------------------------- */
/*                           Shared Skeleton Line                             */
/* -------------------------------------------------------------------------- */

const SkeletonBase = styled(Surface)`
  border-radius: 4px;
  background-image: linear-gradient(
    90deg,
    ${Colors.light} 0px,
    ${Colors.default} 60px,
    ${Colors.light} 120px
  );
  background-size: 200px 100%;
  animation: ${skeletonAnimation} 16s ease-in-out infinite;
  opacity: 0.6;
`

/* -------------------------------------------------------------------------- */
/*                             Layout Wrappers                                */
/* -------------------------------------------------------------------------- */

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
`

export const SectionSkeletonContainer = styled(Surface)`
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

/* -------------------------------------------------------------------------- */
/*                              Skeleton Pieces                               */
/* -------------------------------------------------------------------------- */

export const TitleSkeletonLine = styled(SkeletonBase)`
  height: 26px;
  width: ${props => (props as any).width || '50%'};
  margin-bottom: 12px;
`

export const ContentSkeletonArea = styled(SkeletonBase)`
  height: 140px;
  width: 100%;
`

/* Text lines */

export const TextSkeletonLine = styled(SkeletonBase)<{ width?: string }>`
  height: 16px;
  width: ${props => props.width || '100%'};
`

/* Big block below lines */

export const LargeSkeletonBlock = styled(SkeletonBase)`
  height: 120px;
  width: 100%;
  margin-top: 12px;
`
